<template>
    <div class="appointment-form">
        <div class="d-flex mb-2 mt-4">            
            <h4 class="flex-grow-1">Afspraak maken</h4>
            <b-button type="button"
                class="mr-2"
                variant="outline-primary"
                v-b-tooltip.hover
                title="Afspraak maken"
                @click="create()"
            >
                <fa-icon v-if="!isCreatingAppointment" icon="save" />
                <loader-spinner v-else iscolor="#F0F0F0" :show-spinner="true" />
            </b-button>

            <b-button type="button"
                variant="outline-secondary"
                v-b-tooltip.hover
                title="Sluit"
                @click="$emit('close')"
            >
                <fa-icon icon="times" />
            </b-button>
        </div>

        <div class="jumbotron py-4">
            <autocomplete-person
                label="Zoek een persoon"
                @update:person="loadPerson"
            />

            <hr>

            <span v-if="!form.person_id" class="appointment-form-subtitle">Of voer de afspraakgegevens in:</span>

            <form>
                <general-input
                    class="mb-2"
                    v-model="form.name"
                    label="Naam"
                    placeholder="Voer een naam in"
                    :disabled="!!form.person_id"
                />

                <general-input
                    class="mb-2"
                    v-model="form.email"
                    inputType="email"
                    label="Email"
                    placeholder="info@onderdeboompjes.nl"
                    :disabled="!!form.person_id"
                />

                <general-input
                    class="mb-2"
                    v-model="form.telephone"
                    inputType="tel"
                    label="Telefoonnummer"
                    placeholder="Voer een telefoonnummer in"
                    :disabled="!!form.person_id"
                />

                <general-input
                    v-model="form.note"
                    inputType="textarea"
                    label="Opmerkingen"
                    placeholder="Voer een opmerking in"
                />
            </form>
        </div>
    </div>
</template>

<script>
import GeneralInput from '../../elements/Input/GeneralInput';
import AutocompletePerson from '../../elements/AutocompletePerson';
import LoaderSpinner from '../../elements/LoaderSpinner';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        GeneralInput,
        AutocompletePerson,
        LoaderSpinner
    },
    props: {
        timeSlotId: {
            type: Number,
        }
    },
    data: () => ({
        form: {
            person_id: null,
            name: null,
            email: null,
            telephone: null,
            note: null,
        }
    }),
    computed: {
        ...mapGetters([
            'isCreatingAppointment'
        ])
    },
    methods: {
        ...mapActions([
            'createAppointment',
        ]),

        loadPerson(person) {
            if (!person) {
                this.form = {
                    person_id: null,
                    name: null,
                    email: null,
                    telephone: null,
                    note: null,
                };
            }
            else {
                this.form.name      = person.full_name_simple;
                this.form.email     = person.email;
                this.form.telephone = person.mobile ? person.mobile : person.telephone;
                this.form.person_id = person.id;
            }
        },

        async create() {
            try {
                if (this.form.person_id)
                    await this.createAppointment({ person_id: this.form.person_id, time_slot_id: this.timeSlotId, note: this.form.note });
                else
                    await this.createAppointment({ ...this.form, time_slot_id: this.timeSlotId });


                this.$emit('created');
                this.$emit('close');
            }
            catch (error) {
                console.log(error);
            }
        }
    },
    mounted () {}
}
</script>

<style lang="scss">
.appointment-form {
    legend, &-subtitle {
        color: black;
        font-size: 1rem;
        font-weight: 600;
        display: inline-block;
    }

    &-subtitle {
        margin-bottom: 1.25rem;

    }
}
</style>


// WEBPACK FOOTER //
// AppointmentForm.vue?e900eea6